export default "__VITE_ASSET__BCk8u$Kz__"